import { callDeepLink, isAndroid } from '@croquiscom/web2app';

import { useDayJs } from '@common/hooks';
import { getRuntimeConfigValue } from '@common/next-runtime-config';
import {
  PdpCatalogFulfillmentType,
  useCatalogProductIdParams,
  useCompareAppVersion,
  usePdpBaseInfo,
} from '@domains/pdp-common';

const START_DATE = '2023-09-27';
const END_DATE = '2023-10-03';

export const useZigzinBanner = () => {
  const dayjs = useDayJs();
  const params = useCatalogProductIdParams();
  const {
    product: { fulfillment_type },
  } = usePdpBaseInfo(params);
  const country = 'KR';

  const is_korea = country === 'KR';
  const is_zigzin_product =
    fulfillment_type === PdpCatalogFulfillmentType.ZIGZIN || fulfillment_type === PdpCatalogFulfillmentType.VENDOR_FLEX;
  const is_available_app_version = useCompareAppVersion('6.48.0');

  const is_before = dayjs().isBefore(START_DATE, 'day');
  const is_after = dayjs().isAfter(END_DATE, 'day');

  const is_between = !is_before && !is_after;

  const handleClick = () => {
    callDeepLink('/full_screen_simple_browser')({
      url: encodeURIComponent(`${getRuntimeConfigValue('contentUrl')}/zigzin`),
      zz_scene: 'zigzin_main',
    });
  };

  return {
    is_hide: !is_korea || !is_zigzin_product || !is_available_app_version || is_between,
    handleClick,
  };
};
